/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { SurveyInstanceDataResponse } from '../models/survey-instance-data-response';

@Injectable({
  providedIn: 'root',
})
export class SurveyInstanceDataService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiSurveyInstanceDataGet
   */
  static readonly ApiSurveyInstanceDataGetPath = '/api/SurveyInstanceData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSurveyInstanceDataGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSurveyInstanceDataGet$Plain$Response(params?: {
    type?: string;
    instance?: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<SurveyInstanceDataResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SurveyInstanceDataService.ApiSurveyInstanceDataGetPath, 'get');
    if (params) {
      rb.query('type', params.type, {});
      rb.query('instance', params.instance, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SurveyInstanceDataResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSurveyInstanceDataGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSurveyInstanceDataGet$Plain(params?: {
    type?: string;
    instance?: number;
    context?: HttpContext
  }
): Observable<SurveyInstanceDataResponse> {

    return this.apiSurveyInstanceDataGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SurveyInstanceDataResponse>) => r.body as SurveyInstanceDataResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSurveyInstanceDataGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSurveyInstanceDataGet$Json$Response(params?: {
    type?: string;
    instance?: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<SurveyInstanceDataResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SurveyInstanceDataService.ApiSurveyInstanceDataGetPath, 'get');
    if (params) {
      rb.query('type', params.type, {});
      rb.query('instance', params.instance, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SurveyInstanceDataResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSurveyInstanceDataGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSurveyInstanceDataGet$Json(params?: {
    type?: string;
    instance?: number;
    context?: HttpContext
  }
): Observable<SurveyInstanceDataResponse> {

    return this.apiSurveyInstanceDataGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SurveyInstanceDataResponse>) => r.body as SurveyInstanceDataResponse)
    );
  }

}
